//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import store from "../store/index.js";
import global from "../assets/js/global";
export default {
  name: "Afooter",
  data () {
    return {
      inds: 0,
      footerList: [
        {
          path: "home",
          before: "static/footer/home.png",
          selected: "static/footer/home_s.png",
          name: "小洽",
        },
        {
          path: "specific",
          before: "static/footer/tuijian.png",
          selected: "static/footer/tuijian_s.png",
          name: "技能"
        },
        {
          path: "create",
          before: "static/footer/faxian.png",
          selected: "static/footer/faxian_s.png",
          name: "发现",
        },
        {
          path: "mine",
          before: "static/footer/mine.png",
          selected: "static/footer/mine_s.png",
          name: "我的",
        }
      ],
    };
  },
  methods: {
    selectNav (index) {
      this.inds = index;
      this.$router.replace({ name: this.footerList[index].path });
      this.$emit("getTitle", this.footerList[index].name);
      store.commit("changeInds", index);
      // this.$store.commit
    },
  },
  created () {
    console.log("create", this.inds);
    this.inds = this.$store.state.routerState.inds;
  },
  mounted () {
    if (global.isApp) {
      $api.fixTabBar($api.byId("footer_box"));
    }
  },
  computed: {
    listenshowpage1 () {
      return this.$store.state.routerState.inds;
    },
  },
  watch: {
    listenshowpage1: function (a, b) {
      this.inds = a;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Afooter.vue